import React, { useState, useEffect } from "react";
import apiCall from "./../../API/API";
import { toast } from "react-toastify";
import { CiCirclePlus } from "react-icons/ci";
import { Row, Col, Container, Button } from "react-bootstrap";

const GeneralSettings = () => {
  const [maxWithdrawal, setMaxWithdrawal] = useState("");
  const [minWithdrawal, setMinWithdrawal] = useState("");
  const [advanceData, setAdvanceData] = useState("");
  const [marketPricesStatus, setMarketPricesStatus] = useState(0);
  const [otpBeforeRegister, setOtpBeforeRegister] = useState("yes");

  const fetchData = async () => {
    try {
      const { data, error } = await apiCall("GET", "/get-advance-info");
      setAdvanceData(data?.data);
      const status = data?.data?.Dashboard?.market_prices?.status;
      setMarketPricesStatus(status === 1 ? 1 : 0);
      setOtpBeforeRegister(
        data?.data?.Registration?.otp_before_register?.value || "yes"
      );
    } catch (error) {
      console.log(error?.message);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "maxWithdrawal") {
      setMaxWithdrawal(value);
    } else if (name === "minWithdrawal") {
      setMinWithdrawal(value);
    }
  };
  const handleUpdate = async () => {
    try {
      const { data, error } = await apiCall(
        "POST",
        "/update-withdrawal-limits",
        {
          walletType: "main_wallet",
          maxWithdrawal: maxWithdrawal,
          minWithdrawal: minWithdrawal,
        }
      );
      if (data) {
        toast.success(data.message || "Withdrawal updated successfully!");
        fetchData();
      } else {
        toast.error(error.message || "An error occurred!");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleRegistrationSettingsUpdate = async () => {
    try {
      const { data, error } = await apiCall(
        "POST",
        "/update-registration-settings",
        { otp_before_register: otpBeforeRegister }
      );
      if (data) {
        toast.success(data.message || "Registration setting updated!");
        fetchData();
      } else {
        toast.error(error?.message || "An error occurred!");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleMarketPricesUpdate = async () => {
    try {
      const { data, error } = await apiCall("POST", "/update-market-settings", {
        status: marketPricesStatus,
      });
      if (data) {
        toast.success(data.message || "Market prices setting updated!");
        fetchData();
      } else {
        toast.error(error?.message || "An error occurred!");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <React.Fragment>
      <Container>
        <div className="bonanza-settings">
          <div className="input-row1">
            <h2>Withdrawal setting</h2>
            <div className="input-group1">
              <label>Maximum Withdrawal:</label>
              <input
                type="number"
                name="maxWithdrawal"
                placeholder="Enter Max Withdrawal"
                value={
                  maxWithdrawal ||
                  advanceData?.withdrawal?.main_wallet?.max_withdrawal
                }
                onChange={handleChange}
                required
              />
            </div>
            <div className="input-group1">
              <label>Minimum Withdrawal:</label>
              <input
                type="number"
                name="minWithdrawal"
                placeholder="Enter Min Withdrawal"
                value={
                  minWithdrawal ||
                  advanceData?.withdrawal?.main_wallet?.min_withdrawal
                }
                onChange={handleChange}
                required
              />
            </div>
            <div className="button-container">
              <Button type="submit" variant="primary" onClick={handleUpdate}>
                Update
              </Button>
            </div>
          </div>
        </div>

        <div className="bonanza-settings" style={{ marginTop: "2rem" }}>
          <div className="input-row1">
            <h2>Registration verification</h2>
            <p style={{ marginBottom: "1rem", opacity: 0.85 }}>
              <strong>Yes</strong> — user must verify email with OTP before
              signup. <strong>No</strong> — user registers directly (enable
              welcome email via Registration → send_email in advance info).
            </p>
            <div className="input-group1">
              <label>OTP before registration:</label>
              <select
                value={otpBeforeRegister}
                onChange={(e) => setOtpBeforeRegister(e.target.value)}
              >
                <option value="yes">Yes (OTP before register)</option>
                <option value="no">No (register without pre-OTP)</option>
              </select>
            </div>
            <div className="button-container">
              <Button variant="primary" onClick={handleRegistrationSettingsUpdate}>
                Update registration settings
              </Button>
            </div>
          </div>
        </div>

        <div className="bonanza-settings" style={{ marginTop: "2rem" }}>
          <div className="input-row1">
            <h2>Dashboard market prices</h2>
            <p style={{ marginBottom: "1rem", opacity: 0.85 }}>
              Show live forex, gold (XAU/USD), and top-20 crypto on user dashboard.
              Prices refresh every 5 minutes on the server.
            </p>
            <div className="input-group1">
              <label>Market prices on dashboard:</label>
              <select
                value={marketPricesStatus}
                onChange={(e) => setMarketPricesStatus(Number(e.target.value))}
              >
                <option value={0}>OFF (hidden)</option>
                <option value={1}>ON (visible)</option>
              </select>
            </div>
            <div className="button-container">
              <Button variant="primary" onClick={handleMarketPricesUpdate}>
                Update market settings
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default GeneralSettings;
